import { Zap, Shield, HandHeart } from "lucide-react";

// ─── Legacy tokens (still used by UpgradeSection logic) ───
export const GRADIENT_PREMIUM = "linear-gradient(135deg, #2dd4bf, #3b82f6, #8775f9)";
export const SOLID_PREMIUM = "#8775f9";
export const SOLID_PREMIUM_BG = "#f4f2ff";
export const PREMIUM_ICON_COLOR = "#2dd4bf";
export const BADGE_GRADIENT_PREMIUM = "linear-gradient(135deg, #2dd4bf, #3b82f6)";

// ─── Rebrand v2 tokens (premium minimal palette) ───
export const COLOR_CHARCOAL = "#0a0a0a";
export const COLOR_MUTED = "#52525b";
export const COLOR_SOFT = "#a1a1aa";
export const COLOR_PURPLE = "#8775f9";
export const COLOR_PURPLE_TINT = "#f4f2ff";
export const COLOR_PURPLE_DEEP = "#6d28d9";
export const COLOR_TEAL = "#2dd4bf";
export const COLOR_TEAL_DEEP = "#0d9488";
export const COLOR_SURFACE = "#ffffff";
export const COLOR_SURFACE_ALT = "#fafaff";
export const COLOR_BORDER_SUBTLE = "rgba(0, 0, 0, 0.06)";
export const COLOR_BORDER_HOVER = "rgba(0, 0, 0, 0.12)";

export const SHADOW_CARD = "0 1px 3px rgba(0,0,0,0.04), 0 12px 24px rgba(139,116,255,0.06)";
export const SHADOW_CARD_HOVER = "0 2px 6px rgba(0,0,0,0.06), 0 20px 36px rgba(139,116,255,0.10)";

// ─── Media card backgrounds (Framer assets) ───
export const CARD_BACKGROUNDS = [
  "https://framerusercontent.com/images/rJoQyCJvNOuu8tPa6ca2aBdGUo.png?width=325&height=238",
  "https://framerusercontent.com/images/6mEcYD18eeHYlsGjnPRSf7jA44Q.png?width=325&height=238",
  "https://framerusercontent.com/images/nyzwNVngQQCIqfEpUIyeCBx0VM.jpg?width=325&height=238",
] as const;

export const OVERLAY_REST = "rgba(255, 255, 255, 0.70)";
export const OVERLAY_HOVER = "rgba(255, 255, 255, 0.55)";

export const TRUST_ITEMS = [
  { icon: Zap, label: "Toutes les fonctionnalités incluses" },
  { icon: Shield, label: "Données sécurisées et protégées" },
  { icon: HandHeart, label: "Accompagnement et formation dédiés" },
] as const;
